module.exports = __webpack_public_path__ + "img/Mstorybg701.9da5df27.png";